
import _ from "lodash";
import draggable from "vuedraggable";
import DragVertical from "vue-material-design-icons/DragVertical.vue";

export default {
  name: "ColumnVisibilitySidebar",
  components: { draggable, DragVertical },
  props: {
    id: {
      type: String,
      required: true,
    },
    moduleLabel: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
    visibleFields: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localFields: [],
      selectedFields: new Set(),
    };
  },
  watch: {
    visibleFields: {
      immediate: true,
      deep: true,
      handler() {
        this.syncFromProps();
      },
    },
    fields: {
      deep: true,
      handler() {
        this.syncFromProps();
      },
    },
  },
  methods: {
    isFieldRequired(field) {
      return field.required === true;
    },
    isFieldSelected(fieldKey) {
      return this.selectedFields.has(fieldKey);
    },
    syncFromProps() {
      const visibleKeys = new Set(
        (this.visibleFields || []).map((field) => field.field)
      );
      const allFields = _.cloneDeep(this.fields || []);

      // Visíveis primeiro (na ordem recebida), depois as ocultas (ordem original).
      const orderedVisible = (this.visibleFields || []).filter((field) =>
        allFields.find((f) => f.field === field.field)
      );
      const hiddenFields = allFields.filter(
        (field) => !visibleKeys.has(field.field)
      );

      this.localFields = [...orderedVisible, ...hiddenFields];
      this.selectedFields = new Set(visibleKeys);
    },
    handleToggleField(value, fieldKey) {
      if (value) {
        this.selectedFields.add(fieldKey);
      } else {
        this.selectedFields.delete(fieldKey);
      }
      // Força reatividade do Set
      this.selectedFields = new Set(this.selectedFields);
    },
    handleSave() {
      const savedFields = this.localFields.filter((field) =>
        this.selectedFields.has(field.field)
      );
      this.$emit("save", savedFields);
    },
  },
};
